<template>
  <div class="body">
    <div class="opage">
      <!-- 已提货待确认 -->
      <baseBreadcrumb :page="$t('message.goodsTakenForConfirmation')"
        :menu="$t('message.returnAndExchangeLogistics')" />
      <div class="searchBox">
        <el-date-picker format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
          range-separator="-" v-model="value" :default-time="['00:00:00', '23:59:59']"
          :start-placeholder="$t('message.startDate')" :end-placeholder="$t('message.dateClosed')">
        </el-date-picker>
        <div class="btns">
          <!-- 筛选 -->
          <el-button type="primary" @click="getData">{{
        $t("message.search")
      }}</el-button>
          <!-- 重置 -->
          <!-- <el-button size="small" @click="resetFilter">{{
            $t("message.reset")
          }}</el-button> -->
        </div>
      </div>
      <div style="padding: 0 20px">
        <el-table class="tableMy" :data="tableData"
          :header-cell-style="{ 'text-align': 'center', background: '#EDEFF4' }" :cell-style="{
        'text-align': 'center',
        background: '#f8f8f8',
      }">
          <el-table-column type="index" width="50" label="No">
          </el-table-column>
          <!-- 收货时间 -->
          <el-table-column property="receive_at" :label="$t('message.goodsTime')"></el-table-column>
          <!-- 登记时间 -->
          <el-table-column property="created_at" :label="$t('message.registrationTime')"></el-table-column>
          <!-- 物流号 -->
          <el-table-column property="express_no" :label="$t('message.logisticsNumber')"></el-table-column>
          <!-- 部门 -->
          <el-table-column property="created_at" :label="$t('message.department')">
            <template slot-scope="scope">
              {{ scope.row.admin[0].role[0].organization.name }}
            </template></el-table-column>
          <!-- 提出人 -->
          <el-table-column property="created_by" :label="$t('message.peoplePutForward')"></el-table-column>
          <!-- 签收员 -->
          <el-table-column property="receive_name" :label="$t('message.signForMember')">
            <template slot-scope="scope">
              <div>
                <p>编号暂无</p>
                <p>{{ scope.row.receive_name }}</p>
              </div>
            </template></el-table-column>
          <!-- 收件人信息 -->
          <el-table-column property="receive_mobile" :label="$t('message.receive')">
            <template slot-scope="scope">
              <div>
                <!-- 收件人名字 -->
                <p>{{ scope.row.receive_name }}</p>
                <!-- 收件人电话号码 -->
                <p>{{ scope.row.receive_mobile }}</p>
              </div>
            </template>
          </el-table-column>
          <!-- 件数 -->
          <el-table-column property="num" :label="$t('message.jianShu')"></el-table-column>
          <!-- 运费.元 -->
          <el-table-column property="express_charge" :label="$t('message.RMBfreightCost')"></el-table-column>
          <!-- 提货联系人信息-->
          <el-table-column property="take_mobile" :label="$t('message.pickUpContactInformation')">
            <template slot-scope="scope">
              <div>
                <p>
                  {{ scope.row.take_name }}
                </p>
                <p>
                  {{ scope.row.take_mobile }}
                </p>
              </div>
            </template>
          </el-table-column>
          <!-- 地址、备注-->
          <el-table-column property="remark" :label="$t('message.AddressRemarks')"></el-table-column>
          <!-- 收货底单 -->
          <el-table-column property="receive_image" :label="$t('message.receivingEndOfaSingle')">
            <template slot-scope="scope">
              <div>
                <myImage :imgList="scope.row.receive_image" :showDel="false"></myImage>
              </div>
            </template>
          </el-table-column>
          <!-- 转账记录 -->
          <el-table-column property="transfer_image" :label="$t('message.transferRecord')">
            <template slot-scope="scope">
              <div>
                <myImage :imgList="scope.row.transfer_image" :showDel="false"></myImage>
              </div>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column property="name" :label="$t('message.operation')">
            <template slot-scope="scope">
              <div class="btnGroup">
                <!-- 已收货修改 -->
                <el-button type="primary" @click="modifyThe(scope.row)" v-if="isAuth(306)">{{
        $t("message.theGoodsHaveBeenReceivedAndModified")
      }}</el-button>
                <!-- 退回待提货 -->
                <el-button type="primary" @click="fallback(scope.row)" v-if="isAuth(305)">{{
        $t("message.returnForPickup")
      }}</el-button>
                <!-- 关联交易号 -->
                <el-button type="primary" @click="associated(scope.row)" v-if="isAuth(307)">{{
        $t("message.relatedTransactionNumber")
      }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="allpag">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.page"
          :page-sizes="[10, 20, 30, 50]" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <zDialog ref="theGoodsDia" :config="{
        width: '536px',
        // 已收货修改
        title: $t('message.theGoodsHaveBeenReceivedAndModified'),
        btnTxt: [this.$t('message.ok'), this.$t('message.cancel')],
      }">
      <div class="baoGuoXinXi">
        <el-form ref="shouHuoDiaForm" :model="modifiedInformationHasBeenReceived"
          :rules="verificationOfReceivingInformation" label-position="left" label-width="128px">
          <!-- 件数 -->
          <el-form-item :label="$t('message.jianShu') + ':'" prop="num">
            <el-input v-model="modifiedInformationHasBeenReceived.num"></el-input>
          </el-form-item>
          <!-- 运费.元 -->
          <el-form-item :label="$t('message.RMBfreightCost') + ':'" prop="express_charge">
            <el-input v-model="modifiedInformationHasBeenReceived.express_charge"></el-input>
          </el-form-item>
          <!-- 收货底单 -->
          <el-form-item :label="$t('message.receivingEndOfaSingle') + ':'" prop="receive_image">
            <div class="imgUp">
              <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
                :on-success="(res) => {
        handleAvatarSuccess(res, 'receive_image', 'shouHuoDiaForm');
      }
        " name="file" accept=".jpg,.jpeg,.png" :before-upload="beforeAvatarUpload">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <el-image :src="modifiedInformationHasBeenReceived.receive_image"
                v-if="modifiedInformationHasBeenReceived.receive_image" style="width: 80px; height: 80px">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
                <div slot="placeholder">
                  <i class="el-icon-loading"></i>
                </div>
              </el-image>
            </div>
          </el-form-item>
          <!-- 转账记录 -->
          <el-form-item :label="$t('message.transferRecord') + ':'" prop="transfer_image">
            <div class="imgUp">
              <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
                :on-success="(res) => {
        handleAvatarSuccess(
          res,
          'transfer_image',
          'shouHuoDiaForm'
        );
      }
        " name="file" accept=".jpg,.jpeg,.png" :before-upload="beforeAvatarUpload">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <el-image :src="modifiedInformationHasBeenReceived.transfer_image"
                v-if="modifiedInformationHasBeenReceived.transfer_image" style="width: 80px; height: 80px">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
                <div slot="placeholder">
                  <i class="el-icon-loading"></i>
                </div>
              </el-image>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </zDialog>
    <zDialog ref="associatedDia" :config="{
        width: '536px',
        // 关联交易号
        title: $t('message.relatedTransactionNumber'),
        btnTxt: [this.$t('message.ok'), this.$t('message.cancel')],
      }">
      <div class="baoGuoXinXi">
        <el-form ref="shouHuoDiaForm" :model="transactionNumberInformation" :rules="transactionNumberVerification"
          label-position="left" label-width="128px">
          <!-- 关联交易号 -->
          <el-form-item :label="$t('message.relatedTransactionNumber') + ':'" prop="purchase_no">
            <el-input v-model="transactionNumberInformation.purchase_no"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </zDialog>
  </div>
</template>
<script>
import myImage from "@/components/uploadFile/uploadFile.vue";
export default {
  data() {
    return {
      value: "",
      form: {
        status: 2,
      },
      total: 0,
      loading: null,
      tableData: [],
      diaTit: this.$t("message.offlinePickupRegistration"), //收货修改与添加弹窗标题
      modifiedInformationHasBeenReceived: {}, //已收货修改信息
      verificationOfReceivingInformation: {
        // 件数
        num: [
          // {
          //   required: true,
          //   // 此参数不能为空
          //   message: this.$t("message.thisParameterCannotBeEmpty"),
          //   trigger: "blur",
          // },
        ],
        // 运费.元
        express_charge: [
          // {
          //   required: true,
          //   // 此参数不能为空
          //   message: this.$t("message.thisParameterCannotBeEmpty"),
          //   trigger: "blur",
          // },
        ],
        // 收货底单
        receive_image: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        // 转账记录
        transfer_image: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
      }, //已收货修改表单验证
      transactionNumberInformation: {}, //交易号信息
      transactionNumberVerification: {
        purchase_no: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
      }, //交易号关联表单验证
    };
  },
  components: {
    myImage,
  },
  computed: {},
  mounted() {
    this.getData();
  },
  methods: {
    // 获取数据
    getData() {
      if (!this.value || this.value.length == 0) {
        this.form.start_time = null;
        this.form.end_time = null;
      } else {
        this.form.start_time = this.value[0];
        this.form.end_time = this.value[1];
      }
      this.$api.signInApi.receiveOfflineListNoConfirm(this.form).then((res) => {
        // console.log("事件名", res.data.data);
        if (res.code != 0) return this.$message.error(res.msg);
        // 接下来的操作
        this.tableData = res.data.data;
        this.$forceUpdate();
      });
    },

    // 获取支付列表
    getbillMethods() {
      this.$api.financialApi.billBillMethod().then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(res.msg);
        this.BillMethod = res.data;
      });
    },
    resetFilter() {
      this.value = [];
    },
    // 参数:结果,要改变的数据名,表单ref
    handleAvatarSuccess(res, name, formName) {
      this.loading.close();
      this.modifiedInformationHasBeenReceived[name] = res.data;
      this.validateField(
        "transactionNumberInformation",
        "receive_image",
        formName
      );
    },
    // 手动触发表单验证
    validateField(dataName, type, formRef) {
      if (this[dataName][type])
        this[dataName][type] = this[dataName][type].trim();
      this.$refs[formRef].validateField(type, (v) => {
        if (v == "") {
        } else {
        }
        this.$forceUpdate();
      });
    },
    beforeAvatarUpload(file) {
      const isJPG =
        ["image/jpeg", "image/png", "image/jpg"].indexOf(file.type) != -1;
      //console.log(file.type);
      if (!isJPG) {
        this.$message.error(this.$t("message.pleaseUploadPictures"));
        return isJPG;
      }
      this.loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
    },

    // 关联
    associated(row) {
      this.transactionNumberInformation = {};
      this.$refs.associatedDia.open(
        "",
        () => {
          this.$refs.shouHuoDiaForm.validate((valid) => {
            if (valid) {
              //事件
              this.transactionNumberInformation.id = row.id;
              this.$api.signInApi
                .receiveOfflineBindPurchaseNo(this.transactionNumberInformation)
                .then((res) => {
                  ////console.log('事件名',res)
                  if (res.code != 0) return this.$message.error(res.msg);
                  this.getData();
                  // 操作成功
                  this.$message.success(this.$t("message.operationSucceeded"));
                  this.$refs.associatedDia.close();
                });
            } else {
            }
          });
        },
        () => { }
      );
    },

    // 修改
    modifyThe(row) {
      this.modifiedInformationHasBeenReceived = JSON.parse(
        JSON.stringify({
          id: row.id,
          // num: row.num,
          // express_charge: row.express_charge,
          receive_image: row.receive_image,
          transfer_image: row.transfer_image,
        })
      );
      // 线下提货修改
      this.diaTit = this.$t("message.offlineDeliveryModification");
      this.$refs.theGoodsDia.open(
        "",
        () => {
          this.$refs.shouHuoDiaForm.validate((valid) => {
            if (valid) {
              //事件
              this.$api.signInApi
                .receiveOfflineReceiveUpdate(
                  this.modifiedInformationHasBeenReceived
                )
                .then((res) => {
                  ////console.log('事件名',res)
                  if (res.code != 0) return this.$message.error(res.msg);
                  this.getData();
                });
              this.$refs.theGoodsDia.close();
            } else {
            }
          });
        },
        () => { }
      );
    },
    // 回退
    fallback(row) {
      this.$confirm(
        // 是否退回待提货
        this.$t("message.whetherToReturnGoodsToBePickedUp"),
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.$api.signInApi
            .receiveBackToWaitReceive({ id: row.id })
            .then((res) => {
              ////console.log('事件名',res)
              if (res.code != 0) return this.$message.error(res.msg);
              this.getData();
              // 操作成功
              this.$message.success(this.$t("message.operationSucceeded"));
            });
        })
        .catch(() => { });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.form.pageSize = val;
      this.form.page = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.form.page = val;
      this.getData();
    },
  },
};
</script>

<style lang='scss' scoped>
.opage {
  background-color: #f8f8f8;
  height: 100%;
  padding-bottom: 1px;
}

.searchBox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  padding-left: 24px;
  margin-bottom: 15px;

  >* {
    flex: 0 0 180px;
    margin-right: 20px;
  }

  .el-date-editor {
    flex: 0 0 389px;
  }

  .btns {
    flex: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 0;

    .el-button {

      margin-left: 15px;
    }
  }
}

/deep/.tableMy {
  background-color: transparent;

  th {
    font-size: 14px;
    color: #333;
    font-weight: 400;
  }

  p {
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }

  .keHu {
    p {
      text-align: center;
    }
  }

  .dingDanZhiFuRuJin {
    p {
      text-align: left;
    }
  }

  .lianXiFangShi {
    color: #2c96e7;
    cursor: pointer;
  }

  .link {
    color: #fa5058;
  }

  .btnGroup {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .el-button {
      display: flex;
      margin: 0 0 8px 0;
    }
  }
}

.imgUp {
  display: flex;
  align-items: flex-start;

  /deep/.avatar-uploader .el-upload {
    width: 80px;
    height: 80px;
    margin-right: 10px;
    border: 1px solid #e8e8e8;
    border-radius: 5px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    background-color: white;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }

  /deep/.el-image {
    width: 80px !important;
    height: 80px !important;
  }

  /deep/.imgBox {
    height: 80px;
  }
}

.allpag {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 25px 0;
}
</style>